module.exports = __webpack_public_path__ + "img/loader.1d0d8561.png";